import { Modelo } from '@ext/index';
import * as Types from './Opcion.types';
import moment, { Moment } from 'moment';

export class IOpcion extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Curso: number = 0;
    public Pregunta: number = 0;
    public Opcion: string = '';
    public Correcta: boolean = false;


    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;
        json.curso = this.Curso;
        json.pregunta = this.Pregunta;
        json.opcion = this.Opcion;
        json.correcta = this.Correcta ? 'S' : 'N';


        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Curso = !this.Json.curso ? 0 : this.Json.curso;
        this.Pregunta = !this.Json.pregunta ? 0 : this.Json.pregunta;
        this.Opcion = !this.Json.opcion ? '' : this.Json.opcion;
        this.Correcta = this.Json.correcta == 'S';


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IOpcion )
    {
        this.Model = Model;
    }

    public Model: IOpcion;
}